export const REGISTRATION_FLOWS = {
  DE_COMPANY_CREATION: 'de_company_creation',
  DE_COMPANY_CREATION_SOLE_TRADER: 'de_company_creation_sole_trader',
  DE_FULL_COMPANY_CREATION_FREELANCERS: 'de_full_company_creation_freelancers',
  DE_FULL_COMPANY_CREATION_COMPANIES: 'de_full_company_creation_companies',
  DE_FULL_COMPANY_CREATION_GBR: 'de_full_company_creation_gbr',
  DE_EXISTING_COMPANY: 'de_existing_company',
  DE_EMBED_EXISTING_COMPANY: 'de_embed_existing_company',
  FR_EXISTING_COMPANY: 'fr_existing_company',
  FR_EMBED_EXISTING_COMPANY: 'fr_embed_existing_company',
  FR_EMBED_QF: 'fr_embed_qf',
  FR_WORKS_COUNCIL: 'fr_works_council',
  FR_COMPANY_CREATION: 'fr_company_creation',
  FR_GLOBAL: 'fr_global',
  DE_GLOBAL: 'de_global',
  ES_GLOBAL: 'es_global',
  IT_GLOBAL: 'it_global',
  NL_GLOBAL: 'nl_global',
  AT_GLOBAL: 'at_global',
  BE_GLOBAL: 'be_global',
  PT_GLOBAL: 'pt_global',
  FR_FULL_COMPANY_CREATION_WITH_CAPITAL_DEPOSIT: 'fr_full_company_creation_with_capital_deposit',
  FR_FULL_COMPANY_CREATION_WITHOUT_CAPITAL_DEPOSIT:
    'fr_full_company_creation_without_capital_deposit',
  ES_COMPANY_CREATION: 'es_company_creation',
  ES_EXISTING_COMPANY: 'es_existing_company',
  AT_EXISTING_COMPANY: 'at_existing_company',
  BE_EXISTING_COMPANY: 'be_existing_company',
  NL_EXISTING_COMPANY: 'nl_existing_company',
  NL_COMPANY_CREATION: 'nl_company_creation',
  PT_EXISTING_COMPANY: 'pt_existing_company',
  IT_COMPANY_CREATION: 'it_company_creation',
  IT_EXISTING_COMPANY: 'it_existing_company',
  FR_EXISTING_COMPANY_INVOICING_UPSELL: 'fr_existing_company_invoicing_upsell',
} as const;

export type RegistrationFlow = (typeof REGISTRATION_FLOWS)[keyof typeof REGISTRATION_FLOWS];
